/**
 * Created by AlexanderC on 6/16/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedisDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _RedisClusterException = require('./Exception/RedisClusterException');

var _ioredis = require('ioredis');

var _ioredis2 = _interopRequireDefault(_ioredis);

var _ecad = require('ecad');

var _ecad2 = _interopRequireDefault(_ecad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Redis/Elasticache driver implementation
 */
let RedisDriver = exports.RedisDriver = function (_AbstractDriver) {
  _inherits(RedisDriver, _AbstractDriver);

  /**
   * @param {String} dsn
   */
  function RedisDriver(dsn) {
    _classCallCheck(this, RedisDriver);

    var _this = _possibleConstructorReturn(this, (RedisDriver.__proto__ || Object.getPrototypeOf(RedisDriver)).call(this));

    _this._autoDiscoveryError = null;
    _this._client = null;

    _this._autoDiscover(dsn);
    return _this;
  }

  /**
   * @param {String} dsn
   * @private
   */


  _createClass(RedisDriver, [{
    key: '_autoDiscover',
    value: function _autoDiscover(dsn) {
      let payload = {
        endpoints: [dsn],
        timeout: RedisDriver.DEFAULT_AUTO_DISCOVERY_TIMEOUT
      };

      let client = new _ecad2.default(payload);

      client.fetch((error, hosts) => {
        if (error) {
          this._autoDiscoveryError = error;
        } else {
          let options = {
            sentinels: [],
            name: dsn
          };

          hosts.forEach(host => {
            options.sentinels.push(`redis://${host}/`);
          });

          this._client = new this.NATIVE_DRIVER(options);
        }
      });
    }

    /**
     * @param {Function} cb
     * @private
     */

  }, {
    key: 'clientWait',
    value: function clientWait(cb) {
      if (this._client) {
        cb(null, this._client);
      } else if (this._autoDiscoveryError) {
        cb(this._autoDiscoveryError, null);
      } else {
        setTimeout(() => {
          process.nextTick(() => {
            this.clientWait(cb);
          });
        }, RedisDriver.CLIENT_WAIT_MS_INTERVAL);
      }
    }

    /**
     * @returns {String}
     * @private
     */

  }, {
    key: '_type',
    value: function _type() {
      return 'Redis';
    }

    /**
     * @returns {Error|String|null}
     */

  }, {
    key: '_has',


    /**
     * @param {String} key
     * @param {Function} callback
     */
    value: function _has(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      this.clientWait((error, client) => {
        if (error) {
          callback(new _RedisClusterException.RedisClusterException(error), null);
          return;
        }

        client.exists(key, (error, results) => {
          if (error) {
            callback(new _RedisClusterException.RedisClusterException(error), null);
            return;
          }

          callback(null, results);
        });
      });
    }

    /**
     * @param {String} key
     * @param {Function} callback
     */

  }, {
    key: '_get',
    value: function _get(key) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};

      this.clientWait((error, client) => {
        if (error) {
          callback(new _RedisClusterException.RedisClusterException(error), null);
          return;
        }

        client.get(key, (error, results) => {
          if (error) {
            callback(new _RedisClusterException.RedisClusterException(error), null);

            return;
          }

          callback(null, results);
        });
      });
    }

    /**
     * @param {String} key
     * @param {*} value
     * @param {Number} ttl
     * @param {Function} callback
     */

  }, {
    key: '_set',
    value: function _set(key, value) {
      let ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};

      this.clientWait((error, client) => {
        if (error) {
          callback(new _RedisClusterException.RedisClusterException(error), null);
          return;
        }

        client.set(key, value, ttl, error => {
          if (error) {
            callback(new _RedisClusterException.RedisClusterException(error), null);

            return;
          }

          callback(null, true);
        });
      });
    }

    /**
     * @param {String} key
     * @param {Number} timeout
     * @param {Function} callback
     */

  }, {
    key: '_invalidate',
    value: function _invalidate(key) {
      let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};

      this.clientWait((error, client) => {
        if (error) {
          callback(new _RedisClusterException.RedisClusterException(error), null);
          return;
        }

        client.del(key, timeout, error => {
          if (error) {
            callback(new _RedisClusterException.RedisClusterException(error), null);

            return;
          }

          callback(null, true);
        });
      });
    }

    /**
     * @param {Function} callback
     */

  }, {
    key: '_flush',
    value: function _flush() {
      let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};

      this.clientWait((error, client) => {
        if (error) {
          callback(new _RedisClusterException.RedisClusterException(error), null);
          return;
        }

        client.flushall(error => {
          if (error) {
            callback(new _RedisClusterException.RedisClusterException(error), null);

            return;
          }

          callback(null, true);
        });
      });
    }

    /**
     * @returns {*|exports|module.exports}
     * @constructor
     */

  }, {
    key: 'autoDiscoveryError',
    get: function get() {
      return this._autoDiscoveryError;
    }

    /**
     * @returns {Redis}
     */

  }, {
    key: 'client',
    get: function get() {
      return this._client;
    }
  }, {
    key: 'NATIVE_DRIVER',
    get: function get() {
      return _ioredis2.default;
    }

    /**
     * @returns {Number}
     */

  }], [{
    key: 'CLIENT_WAIT_MS_INTERVAL',
    get: function get() {
      return 5;
    }

    /**
     * @returns {Number}
     */

  }, {
    key: 'DEFAULT_AUTO_DISCOVERY_TIMEOUT',
    get: function get() {
      return 700;
    }
  }]);

  return RedisDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/RedisDriver.js
// module id = 354
// module chunks = 0